angular.module('aprima-core').factory('BrowserService',
    [
        '$window',
         '$log',
         'DeviceSettings', 
    function (
        $window, 
        $log,
        DeviceSettings
    ) {
        'use strict';

        var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
            ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/),
            ieEDGE = navigator.userAgent.match(/Edge/g),
            ieVer = (ie ? ie[1] : (ie11 ? 11 : (ieEDGE ? 12 : -1)));

        function base64ToBlob(base64String, contentType){
            var byteCharacters = atob(base64String);
            var byteArray = new Array(byteCharacters.length);

            for (var i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }
            var byteArrayInt = new Uint8Array(byteArray);

            return new Blob([byteArrayInt], {type: contentType});
        }

        function downloadDocumentToFile(fileNameToSaveAs, base64String, contentType, document){
            if (!isBlobCompatible()) {
                return;
            }

            var blob = base64ToBlob(base64String, contentType);
            saveBlob(document, blob, fileNameToSaveAs);
        }

        function isBlobCompatible(){
            if (ie && ieVer<10) {
                $log('No blobs on IE ver<10');
                return false;
            }
            return true;
        }

        function isLegacyIE() {
            return !!(ie || ie11);
        }

        function isIE(){
            return !!(ie || ie11 || ieEDGE);
        }

        function saveBlob(document, blobObj, fileName) {
            if (ieVer > -1) {
                $window.navigator.msSaveBlob(blobObj, fileName);

            } else {
                var downloadLink = document.createElement('a');
                downloadLink.download = fileName;
                downloadLink.href = $window.URL.createObjectURL(blobObj);
                downloadLink.onclick = function (e) {
                    document.body.removeChild(e.target);
                };
                downloadLink.style.display = 'none';
                document.body.appendChild(downloadLink);
                downloadLink.click();
            }
        }

        function supportsInlinePdf() {
            if (isIE() || DeviceSettings.isIos || DeviceSettings.isAndroid) {
                return false;
            }
            return true;
        }

        return {
            base64ToBlob : base64ToBlob,
            downloadDocumentToFile : downloadDocumentToFile,
            isBlobCompatible: isBlobCompatible,
            isIE: isIE,
            isLegacyIE: isLegacyIE,
            saveBlob: saveBlob,
            supportsInlinePdf: supportsInlinePdf,
        };
    }
    ]);